import {FormattedMessage, injectIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import {ALERT_TYPES, SDC_FIELD_TYPES} from "../../Constants";
import Button from "@amzn/meridian/button";
import Tag from "@amzn/meridian/tag";
import axios from "axios";
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint} from "../../Utils";
import Alert from "@amzn/meridian/alert";
import {fetchTemplates} from "../../NetworkUtils";
import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb"
import {CREATE_FEATURES_BASE_ROUTE} from "../util/RouteConstants";

const SDCConfiguration = (props) => {

    const [sdcTemplate, setSdcTemplate] = useState();
    const [configName, setConfigName] = useState();
    const [ripName, setRipName] = useState();
    const [schemaVersion, setSchemaVersion] = useState();
    const [fieldName, setFieldName] = useState();
    const [fieldType, setFieldType] = useState();
    const [showMcmButton, setShowMcmButton] = useState(false);
    const [fields, setFields] = useState([]);
    const [historyProps, setHistoryProps] = useState([{featureId: "", configId: "", mcmId: ""}]);
    const [sdcTemplates, setSdcTemplates] = useState([]);
    const [alert, setAlert] = useState({visible: false, text:"", type:""})
    const warningAlert = {visible: true, text: "Create SDC Config request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully created SDC Config", type:ALERT_TYPES.SUCCESS};

    useEffect(() => {
        try {
            setHistoryProps({
                featureId: props.location.state.featureId,
                configId: props.location.state.configId,
                mcmId: props.location.state.mcmId
            });
            setSdcTemplate(props.location.state.template);
            setConfigName(props.location.state.configName);
            setRipName(props.location.state.ripName);
            setSchemaVersion(props.location.state.schemaVersion);
            setFields(props.location.state.fields ? props.location.state.fields : []);
        } catch(error) {}

        fetchTemplates("SDC").then(response => setSdcTemplates(response));
    }, []);

    useEffect(() => {
        if (!historyProps || !historyProps.mcmId) {
            setShowMcmButton(true);
        }
    }, [historyProps]);

    const removeField = (fieldToBeRemoved) => {
        const fieldsCopy = fields.filter(field => {return field !== fieldToBeRemoved;})
        setFields(fieldsCopy);
    }

    const addField = () => {
        const newField = {name: fieldName, type: fieldType};
        const fieldsCopy = Array.from(fields);
        fieldsCopy.push(newField);
        setFields(fieldsCopy);
    }

    const createConfig = () => {
        setAlert(warningAlert);
        const params = {
            sdcConfiguration: {
                featureId: historyProps.featureId,
                configurationId: historyProps.configId,
                configName: configName,
                template: sdcTemplate,
                ripServiceName: ripName,
                schemaVersion: schemaVersion,
                mcmId: historyProps.mcmId,
                fields: fields
            }
        };
        (async ()=>{
            const headers = await getHeadersForNFMS("CreateSdcConfiguration");
            axios
                .post(getNFMSEndpoint(), params, headers)
                .then((response) => {
                    if (response.status === 200) {
                        setAlert(successAlert);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                })
        })();
    }

    return (
        <div className="App">
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <BreadcrumbGroup>
                        <Breadcrumb href={`#${CREATE_FEATURES_BASE_ROUTE}`}>
                            <FormattedMessage id="createConfig.heading" defaultMessage="Create New Configuration"/>
                        </Breadcrumb>
                        <Breadcrumb href={"#"}>
                            <FormattedMessage id="sdcConfig.heading" defaultMessage="Create New SDC Configuration"/>
                        </Breadcrumb>
                    </BreadcrumbGroup>
                </Column>
            </Row>
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="medium none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="sdcConfig.template" defaultMessage="Template"/>
                    </Text>
                    <Select value={sdcTemplate} onChange={setSdcTemplate} placeholder="Select Template" width={400}>
                        {sdcTemplates.map(template => (
                            <SelectOption label={template} value={template} key={template} />
                        ))}
                    </Select>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="sdcConfig.configName" defaultMessage="SDC Config Name"/>
                    </Text>
                    <Input id="config-name" value={configName} width={400}
                           onChange={setConfigName} type="text" placeholder="Enter SDC Config name"/>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="sdcConfig.ripName" defaultMessage="RIP Service Name"/>
                    </Text>
                    <Input id="rip-name" value={ripName} width={400}
                           onChange={setRipName} type="text" placeholder="Enter RIP Service name"/>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="sdcConfig.schemaVersion" defaultMessage="Schema Version"/>
                    </Text>
                    <Input id="schema-version" value={schemaVersion} width={400}
                           onChange={setSchemaVersion} type="text" placeholder="Enter Schema Version"/>
                </Column>
            </Row>

            {showMcmButton ?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="sdcConfig.mcm" defaultMessage="MCM Id"/>
                        </Text>
                        <Input id="mcm-input" value={historyProps.mcmId}
                               onChange={id => setHistoryProps({...historyProps, mcmId: id})}
                               type="text" placeholder="Enter MCM Id" width={400}/>
                    </Column>
                </Row>
                : null}

            <Row alignmentVertical="top" spacingInset="large large small none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="sdcConfig.fieldName" defaultMessage="Field Name"/>
                    </Text>
                    <Input id="field-name" value={fieldName} width={150}
                           onChange={setFieldName} type="text" placeholder="Field Name"/>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="sdcConfig.fieldType" defaultMessage="Field Type"/>
                    </Text>
                    <Select value={fieldType} onChange={setFieldType} placeholder="Field Type" width={130}>
                        {Object.entries(SDC_FIELD_TYPES).map(([key, value]) => (
                            <SelectOption label={key} value={value} key={key} />
                        ))}
                    </Select>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="sdcConfig.addButton" defaultMessage="."/>
                    </Text>
                    <Button type="secondary" onClick={() => addField()}>
                        <FormattedMessage id="sdcConfig.addButton" defaultMessage="Add Field"/>
                    </Button>
                </Column>
            </Row>

            <Row alignmentVertical="top" spacingInset="small small small none" wrap="down">
                {fields.map(field => (
                    <Tag type="neutral" key={field.name} onClose={() => removeField(field)}>
                        {field.name + " (" + field.type + ")"}
                    </Tag>
                ))}
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="xlarge large large none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Button onClick={createConfig}>
                        <FormattedMessage id="sdcConfig.create" defaultMessage="Create Config"/>
                    </Button>
                </Column>
            </Row>
            <Row alignmentVertical="top" spacingInset="none none medium none">
                {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
            </Row>
        </div>
    );
}

export default injectIntl(SDCConfiguration);


// WEBPACK FOOTER //
// ./src/components/create-config/SDCConfiguration.js